//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavVersions(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 2H18V4H6V2Z" fill="currentColor" /><path d="M4 6H20V8H4V6Z" fill="currentColor" /><path d="M3 10V18H5V12H19V20H3V22H21V10H3Z" fill="currentColor" /></svg>;
}
export default IconNavVersions;